/**
 * CANDIDATE COPY, not approved: awaiting Charles's approval before merge (verifime-adr#617).
 *
 * Every string RequestBannerStepper shows by default. Each string below is new copy, marked
 * CANDIDATE. The caller can replace any of them through the `copy` prop.
 */

export type RequestBannerStepperCopy = {
  /** The small label before the counter. Also the name of the banner for a screen reader. */
  openRequests: string;
  /** The counter, from the step (counted from 1) and the number of open requests. */
  counter: (step: number, total: number) => string;
  /** The words before what a typed request asks for. */
  asksFor: string;
  /** The whole line for a Legacy request, which asks for any identity and names no type. */
  legacyAsks: string;
  /** The name of the button that steps to the previous request. */
  back: string;
  /** The name of the button that steps to the next request. */
  next: string;
  /** The name of the dot that jumps to a request, from its place (counted from 1) and the number of open requests. */
  dotLabel: (position: number, total: number) => string;
  /** The primary button on a typed step. */
  start: string;
  /** The primary button on a Legacy step. */
  share: string;
};

export const REQUEST_BANNER_STEPPER_COPY: RequestBannerStepperCopy = {
  // CANDIDATE COPY, not approved (verifime-adr#617)
  openRequests: 'Open requests',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  counter: (step, total) => `${step} of ${total}`,
  // CANDIDATE COPY, not approved (verifime-adr#617)
  asksFor: 'asks for',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  legacyAsks: 'asks you to share your identity (Legacy, any identity)',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  back: 'Previous request',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  next: 'Next request',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  dotLabel: (position) => `Go to request ${position}`,
  // CANDIDATE COPY, not approved (verifime-adr#617)
  start: 'Start',
  // CANDIDATE COPY, not approved (verifime-adr#617)
  share: 'Share',
};

/** Overrides for the default copy. Any string may be left out. A string set to `undefined` counts as left out. */
export type RequestBannerStepperCopyOverrides = Partial<RequestBannerStepperCopy>;

/** The default copy with the caller's overrides laid over it, one string at a time. */
export function resolveRequestBannerStepperCopy(
  overrides: RequestBannerStepperCopyOverrides = {},
): RequestBannerStepperCopy {
  const given = Object.fromEntries(
    Object.entries(overrides).filter(([, text]) => text !== undefined),
  );
  return { ...REQUEST_BANNER_STEPPER_COPY, ...given };
}
